import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-toll-tax-tooltip',
  templateUrl: './toll-tax-tooltip.component.html',
})
export class TollTaxTooltipComponent implements OnInit {
  @Input() toll: any;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component/toll-tax-tooltip/toll-tax-tooltip.component.ts